
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAircraftDroneSmall as ObiAircraftDroneSmallElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-aircraft-drone-small.js';
 
 
 

 
 export const ObiAircraftDroneSmall = createComponent({
   react: React,
   tagName: 'obi-aircraft-drone-small',
   elementClass: ObiAircraftDroneSmallElement,
   events: {
     
   }
  });
 
 